const routes = [
  {
    path: 'masonry',
    name: 'masonry',
    component: () => import(/* webpackChunkName: "masonry" */ '@/modules/masonry/index.vue'),
    children: [
      {
        path: '',
        name: 'masonry',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/masonry/demo1.vue')
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/masonry/demo1.vue')
      },
      {
        path: 'demo2',
        name: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/masonry/demo2.vue')
      },
      {
        path: 'demo3',
        name: 'demo3',
        component: () => import(/* webpackChunkName: "demo3" */ '@/modules/masonry/demo3.vue')
      },
      {
        path: 'demo4',
        name: 'demo4',
        component: () => import(/* webpackChunkName: "demo4" */ '@/modules/masonry/demo4.vue')
      },
      {
        path: 'demo5',
        name: 'demo5',
        component: () => import(/* webpackChunkName: "demo5" */ '@/modules/masonry/demo5.vue')
      },
      {
        path: 'demo6',
        name: 'demo6',
        component: () => import(/* webpackChunkName: "demo6" */ '@/modules/masonry/demo6.vue')
      },
    ]
  },
];

export default routes;